import { getArticleResultsByFEContextKey } from '#pplx/frontend/apps/ask/queries/query-keys/articleKeys.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export function isInfiniteQueryData(data) {
    return (typeof data === 'object' &&
        data !== null &&
        'pages' in data &&
        Array.isArray(data.pages) &&
        'pageParams' in data &&
        Array.isArray(data.pageParams));
}
export const getCachedThreadCollection = (queryClient, frontendContextUUID) => {
    const data = queryClient.getQueryData(['results']);
    return data?.find((message) => message.frontend_context_uuid === frontendContextUUID)
        ?.collection_info;
};
export const getCachedArticleCollection = (queryClient, frontendContextUUID) => {
    const data = queryClient.getQueryData(getArticleResultsByFEContextKey(frontendContextUUID));
    return data?.find((message) => message.frontend_context_uuid === frontendContextUUID)
        ?.collection_info;
};
export const updateArticleResultsCache = (queryClient, frontendContextUUID, messageMutator) => {
    queryClient.setQueryData(getArticleResultsByFEContextKey(frontendContextUUID), (oldData) => {
        if (!oldData)
            return oldData;
        return oldData.map(messageMutator);
    });
};
export const updateCollectionCaches = (queryClient, params, listItemsKey, resultsStore, mutateResults) => {
    const { entryUUID, frontendContextUUID, newCollectionUUID, newCollectionTitle, newCollectionEmoji, newCollectionSlug, newCollectionAccess, newCollectionUserPermission, } = params;
    const extra_message_fields = {
        collection_info: {
            uuid: newCollectionUUID,
            title: newCollectionTitle,
            emoji: newCollectionEmoji,
            slug: newCollectionSlug,
            access: newCollectionAccess,
            user_permission: newCollectionUserPermission,
        },
        bookmark_state: 'BOOKMARKED',
    };
    if (frontendContextUUID) {
        // updating ThreadHeader on /search/[...slug], thus we access it via frontendContextUUID
        mutateResults((oldData) => {
            if (!oldData)
                return [];
            return oldData.map((message) => {
                if (message.frontend_context_uuid === frontendContextUUID) {
                    return {
                        ...message,
                        ...extra_message_fields,
                    };
                }
                return message;
            });
        });
        // pages store results under a different key and data format
        queryClient.setQueryData(QueryClientHelper.makeQueryKey(resultsStore, {
            frontend_context_uuid: frontendContextUUID,
        }), (oldData) => {
            if (!oldData)
                return [];
            return oldData.map((message) => {
                if (message.frontend_context_uuid === frontendContextUUID) {
                    return {
                        ...message,
                        ...extra_message_fields,
                    };
                }
                return message;
            });
        });
    }
    // optimistic update of the thread
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY_MIGRATION: Please fix in passing
    queryClient.setQueryData(listItemsKey, (oldData) => {
        oldData = oldData || { pages: [], pageParams: [] };
        const updatedPages = oldData.pages.map((page) => page.map((thread) => thread.uuid === entryUUID
            ? {
                ...thread,
                collection: {
                    ...thread.collection,
                    ...extra_message_fields.collection_info,
                },
            }
            : thread));
        return {
            ...oldData,
            pages: updatedPages,
        };
    });
};
//# sourceMappingURL=cache-helpers.js.map